import React, { useState, useEffect, useMemo } from "react";
import "./BookingPage.css";
import axiosConfig from "../../Service/AxiosConfig";
import { CiSearch } from "react-icons/ci";
import { useNavigate } from "react-router-dom";
import loader from "../Animations/Sandy Loading.gif";
import BookingList from "./BookingList";

const TABS = ["All", "In Progress", "Completed"];

const BookingsPage = () => {
  const [activeTab, setActiveTab] = useState("All");
  const [bookings, setBookings] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const getBookings = async () => {
    try {
      setLoading(true);
      const res = await axiosConfig.get("/accounts/patients/");
      setBookings(res?.data?.results || []);
    } catch (err) {
      console.error("Error fetching bookings:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getBookings();
  }, []);

  const formatDate = (isoDate) => {
    if (!isoDate) return "";
    return new Date(isoDate).toLocaleDateString("en-IN", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  };

  const normalizeStatus = (status = "") => {
    const s = status.toLowerCase();
    if (s.includes("completed")) return "Completed";
    return "In Progress";
  };

  const filteredBookings = useMemo(() => {
    return bookings.filter((item) => {
      const status = normalizeStatus(item?.lead?.lead_status_name);
      if (activeTab !== "All" && status !== activeTab) {
        return false;
      }
      if (searchTerm.trim()) {
        const term = searchTerm.toLowerCase();
        return (
          item?.lead?.name?.toLowerCase().includes(term) ||
          item?.service_name?.toLowerCase().includes(term) ||
          String(item?.lead?.lead_id || "").includes(term)
        );
      }

      return true;
    });
  }, [bookings, activeTab, searchTerm]);

  const handleEdit = (id) => {
    if (!id) return;
    navigate(`/patient-dashboard/bookings/${id}`);
  };
  if (loading) {
    return (
      <div className="loader-wrapper">
        <img src={loader} alt="Loading..." />
      </div>
    );
  }

  return (
    <div className="patient-dashboard-child">
      <div className="profile">
        <h3>My Bookings</h3>
        <button className="book-service-btn">Book Service</button>
      </div>

      <div className="booking-wrapper">
        <div className="booking-flex">
          <div className="booking-tabs">
            {TABS.map((tab) => (
              <button
                key={tab}
                className={`booking-tab ${activeTab === tab ? "active" : ""}`}
                onClick={() => setActiveTab(tab)}
              >
                {tab}
              </button>
            ))}
          </div>

          <div className="booking-search">
            <CiSearch size={20} />
            <input
              type="text"
              placeholder="Search"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </div>
        </div>

        <BookingList
          bookings={filteredBookings}
          onCardClick={(item) => handleEdit(item?.id)}
          mode="list"
        />
      </div>
    </div>
  );
};

export { BookingsPage };
